import React, { Component } from 'react';
import { connect } from 'react-redux';
import './GeneralContractorDetails.css';
import { goToProjectDetails } from 'components/admin/projects/store/actions';
import {
  loadGeneralContractorRequest,
  loadGeneralContractorProjectsRequest,
  goToEditGeneralContractor,
  showContactsRequest,
  showContactsModal,
  setGeneralContractorUsers,
} from 'components/admin/general-contractors/store/actions.js';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import DetailsHeader from 'components/shared/details/DetailsHeader';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import DetailsInfo from 'components/shared/details/DetailsInfo';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import { GENERAL_CONTRACTOR_ROLES, TYPES } from 'services/utils/users-util';
import {
  getCurrentGeneralContractor,
  getProjectsCurrentPage,
  getProjects,
  getUsers,
  getShowContactsModal,
} from 'components/admin/general-contractors/store/selectors';
import SimpleTable from 'components/shared/table/SimpleTable';
import SearchBar from 'components/shared/navigation/SearchBar';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import { formatPhoneNumber } from 'services/utils/text-util';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import numeral from 'numeral';
import ContactsModal from 'components/shared/modal/ContactsModal';
import SimpleText from 'components/shared/text/SimpleText';
import ProjectStatus from 'components/shared/project-status/ProjectStatus';
import { ProjectStatusEnum } from 'domain/project-status-enum';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { simpleScrollToTop } from 'services/utils/scroller-util';

class GeneralContractorDetails extends Component {
  tabSelection = 1;

  constructor(props) {
    super(props);
    this.generalContractorId = numeral(this.props.match.params.id).value();
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  componentDidMount() {
    this.props.dispatch(setGeneralContractorUsers([]));
    this.props.dispatch(loadGeneralContractorRequest(this.generalContractorId));
    this.props.dispatch(
      loadGeneralContractorProjectsRequest(this.generalContractorId, 1)
    );
  }

  handleEdit = () => {
    this.props.dispatch(goToEditGeneralContractor(this.generalContractorId));
  };

  handleRowSelection = (index) => {
    this.props.dispatch(
      goToProjectDetails(this.props.projects.content[index].id)
    );
  };

  handleNavSelect = (id) => {
    this.tabSelection = id;
    this.loadProjects(id, 1);
  };

  handlePageChange = (newPage) => {
    this.loadProjects(this.tabSelection, newPage);
  };

  handleViewAll = (event) => {
    event.preventDefault();
    this.props.dispatch(
      showContactsRequest(this.props.generalContractor.id, this.props.users)
    );
  };

  handleContactsModalClose = () => {
    this.props.dispatch(showContactsModal(false));
  };

  loadProjects(tabSelection, newPage) {
    switch (tabSelection) {
      case 1:
        this.props.dispatch(
          loadGeneralContractorProjectsRequest(
            this.generalContractorId,
            newPage
          )
        );
        break;

      case 2:
        this.props.dispatch(
          loadGeneralContractorProjectsRequest(
            this.generalContractorId,
            newPage,
            'pending'
          )
        );
        break;

      case 3:
        this.props.dispatch(
          loadGeneralContractorProjectsRequest(
            this.generalContractorId,
            newPage,
            'in_progress'
          )
        );
        break;

      case 4:
        this.props.dispatch(
          loadGeneralContractorProjectsRequest(
            this.generalContractorId,
            newPage,
            'complete'
          )
        );
        break;

      default:
    }
  }

  mapUsers = (users) => {
    return users.map((user) => {
      return {
        email: user.email,
        lastSignIn: user.current_sign_in_at,
        name: `${user.first_name} ${user.last_name}`,
        phoneNumber: user.phone_number,
        primaryContact: user.account_creator,
        title: this.mapTitle(user.roles),
      };
    });
  };

  mapTitle(roles) {
    const titles = roles
      .filter((role) => role.resource_type === TYPES.GENERAL_CONTRACTOR)
      .map((role) => {
        return GENERAL_CONTRACTOR_ROLES[role.name];
      });

    if (titles.length > 1) {
      return titles.join(' / ');
    } else if (titles.length === 1) {
      return titles[0];
    } else {
      return 'N/A';
    }
  }

  mapProjects = (projects) => {
    return projects.map((project) => {
      return [
        project.number,
        project.name,
        project.client.company_name,
        <SimpleText
          lines={[
            project.building.location.street_address_1,
            project.building.location.city,
          ]}
        />,
        <ProjectStatus status={ProjectStatusEnum.create(project.status)} />,
      ].filter((attr) => attr);
    });
  };

  render() {
    let detailsInfoItems = [];

    if (this.props.generalContractor) {
      if (this.props.generalContractor.location) {
        detailsInfoItems.push(
          <DetailsInfoItem
            lines={[
              this.props.generalContractor.location.street_address_1,
              this.props.generalContractor.location.city +
                ', ' +
                this.props.generalContractor.location.state +
                ' ' +
                this.props.generalContractor.location.zip,
            ]}
            title="ADDRESS"
          />
        );
      }

      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[
            <span className="general-contractor-name">
              {`${this.props.generalContractor.contact.first_name} ${this.props.generalContractor.contact.last_name}`}
            </span>,
            <a
              className="general-contractor-email"
              href={`mailto:${this.props.generalContractor.contact.email}`}
            >
              {this.props.generalContractor.contact.email}
            </a>,
            formatPhoneNumber(
              this.props.generalContractor.contact.phone_number
            ),
          ]}
          title={
            <div>
              <span>PRIMARY CONTACT</span>
              <span className="view-all" onClick={this.handleViewAll}>
                View All
              </span>
            </div>
          }
        />
      );

      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[this.props.generalContractor.license_number]}
          title="LICENSE NUMBER"
        />
      );
    }

    return (
      this.props.generalContractor && (
        <div className="team">
          <RouteTitle
            titles={[
              'COMPANY',
              this.props.generalContractor.name.toUpperCase(),
            ]}
          />

          <DetailsHeader
            leftHeader={{
              title: 'COMPANY',
              value: this.props.generalContractor.name,
            }}
            leftHeaderExtraComponents={
              this.props.generalContractor.logo &&
              this.props.generalContractor.logo.image && (
                <div className="logo-preview-container">
                  <LogoUpload
                    extensions={['.jpg', '.jpeg', '.gif', '.png']}
                    logos={[
                      {
                        preview: this.props.generalContractor.logo.image.url,
                        url: this.props.generalContractor.logo.image.url,
                      },
                    ]}
                    readOnly={true}
                  />
                </div>
              )
            }
            rightHeaders={[
              [
                {
                  title: 'STATUS',
                  value: (
                    <ContractorStatus
                      status={this.props.generalContractor.status}
                    />
                  ),
                },
              ],
            ]}
          />

          <div className="details-info-container">
            <DetailsInfo
              itemsContainerSize={12}
              itemsLines={[detailsInfoItems]}
            />

            <div className="edit-button-container">
              <input
                type="button"
                className="btn button button-gray"
                value="Edit"
                onClick={this.handleEdit}
              />
            </div>
          </div>

          {this.props.projects && (
            <div className="content-container">
              <SearchBar>
                <NavigationBar
                  items={[
                    {
                      id: 1,
                      title: 'All',
                    },
                    {
                      id: 2,
                      show: this.props.projects.totalPending > 0,
                      title: 'Pending',
                      total: this.props.projects.totalPending,
                    },
                    {
                      id: 3,
                      show: this.props.projects.totalInProgress > 0,
                      title: 'In Progress',
                      total: this.props.projects.totalInProgress,
                    },
                    {
                      id: 4,
                      show: this.props.projects.totalComplete > 0,
                      title: 'Complete',
                      total: this.props.projects.totalComplete,
                    },
                  ]}
                  onSelected={this.handleNavSelect}
                />
              </SearchBar>

              <SimpleTable
                className="projects-table"
                headers={[
                  'PROJECT #',
                  'NAME',
                  'CLIENT NAME',
                  'LOCATION',
                  'STATUS',
                ].filter((header) => header)}
                rows={this.mapProjects(this.props.projects.content)}
                emptyMessage="No Projects"
                onRowSelected={this.handleRowSelection}
              />

              <div className="pagination-container">
                <SimplePagination
                  currentPage={this.props.currentPage}
                  pageSize={this.props.projects.pageSize}
                  total={this.props.projects.total}
                  onPageChange={this.handlePageChange}
                />
              </div>
            </div>
          )}

          <ContactsModal
            show={this.props.showContactsModal}
            users={this.mapUsers(this.props.users)}
            onClose={this.handleContactsModalClose}
          />
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    generalContractor: getCurrentGeneralContractor(state),
    projects: getProjects(state),
    users: getUsers(state),
    showContactsModal: getShowContactsModal(state),
    currentPage: getProjectsCurrentPage(state),
  };
})(GeneralContractorDetails);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/GeneralContractorDetails.js